module.exports = __webpack_public_path__ + "img/man-profile.aad1d666.svg";